/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface Evaluation { 
    id: number;
    title: string;
    textColor: string;
    backgroundColor: string;
    minPoint: number;
    maxPoint: number;
    minPercent: number;
    maxPercent: number;
    code: number;
}